/** Angular */
import { Injectable } from '@angular/core';

@Injectable()
export class ArrayUtilsService {

	/**
	 * Filters all duplicated values from any array
	 *
	 * @param array: Pass an untyped Array
	 */
	filterDuplicates(array: any[]): any[] {
        return array.filter((value, index) => array.indexOf(value) === index); 
    }
}
